import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class TipoNCNDService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  // GetSegunTipoNCND(tipo_ncnd_codigo: Number, tipo_filtro_ncnd: Number, callback: Function) {
  GetSegunTipoNCND(inputData: {
    // tipo_ncnd_codigo: number
    tipo_filtro_ncnd: number
    rut_emisor: number
    tipo_dte_codigo: number
    folio: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query($entidad:tipo_ncndInputType){
          tipo_ncnd{
            obtenerSegunTipoNCND(filtro:{exacto:$entidad}){
              respuesta{
                registros{
                  codigo
                  nombre
                  descripcion
                  afecta_nc
                  afecta_nd
                }
              }
            }
          }
        }
        `,
        variables: {entidad:inputData},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_ncnd.obtenerSegunTipoNCND
        callback({ mensajes, respuesta })
      }
    );
  }

  GetNotaCreditoTipo(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query($entidad:tipo_ncndInputType){
          tipo_ncnd{
            obtenerFiltroNotaCredito(entidad:$entidad){
              respuesta{
                registros{
                  codigo
                  nombre
                  descripcion
                  afecta_nc
                  afecta_nd
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_ncnd.obtenerFiltroNotaCredito
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerSegunFiltroReporteNotaCredito(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($filtro: FiltroInputTypeOftipo_ncndTOtipo_ncndInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          tipo_ncnd {
            obtenerSegunFiltroReporteNotaCredito(filtro: $filtro,paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                tipo
                texto
                codigo
                contexto
                __typename
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  folio
                  tipo_ncnd_nombre
                  fecha_emision
                  doc_ref
                  sucursal_nombre
                  motivo_dev_nombre
                  rut_cliente
                  cliente_nombre
                  vendedor_rut
                  vendedor_nombre
                  monto
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_ncnd.obtenerSegunFiltroReporteNotaCredito
        callback({ mensajes, respuesta })
      }
    );
  }


  obtenerSegunFiltroReporteNotaCreditoExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($filtro: FiltroInputTypeOftipo_ncndTOtipo_ncndInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          tipo_ncnd {
            obtenerSegunFiltroReporteNotaCredito(filtro: $filtro, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rutaArchivo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_ncnd.obtenerSegunFiltroReporteNotaCredito
        callback({ mensajes, respuesta })
      }
    );
  }
}
